/* Existing merchant codes; eligibility and discount amounts are always Shopify-owned. */
(()=>{
 const cfg=window.AAGRAH_SHOP||{},codes=cfg.offerCodes||{},root=cfg.root||'/';
 const clean=value=>String(value||'').trim(),normal=value=>clean(value).toLowerCase();
 const managed=['fashion3','fashion6','premium3','premium6'].map(k=>normal(codes[k])).filter(Boolean).concat(['b2g1-18','b3g3-18']);
 function appliedCodes(cart){
  const applications=[...(cart.cart_level_discount_applications||[]),...(cart.items||[]).flatMap(item=>(item.line_level_discount_allocations||[]).filter(a=>a.amount>0).map(a=>a.discount_application))];
  return [...new Set([...(cart.discount_codes||[]).filter(d=>d.applicable===true).map(d=>clean(d.code)),...applications.filter(d=>d?.type==='discount_code').map(d=>clean(d.title))].filter(Boolean))];
 }
 function select(state){
  if(!cfg.offers||!codes.enabled)return [];
  let fashion=0,premium=0;
  for(const item of state.cart.items){const meta=state.lines[item.key];if(meta?.eligible===true){if(meta.premium===true)premium+=item.quantity;else fashion+=item.quantity;}}
  const tier=(n,range)=>n>=6?codes[range+'6']:n>=3?codes[range+'3']:'';
  const chosen=codes.rule==='mixed'?[tier(fashion+premium,fashion?'fashion':'premium')]:[tier(fashion,'fashion'),tier(premium,'premium')];
  return [...new Set(chosen.map(clean).filter(Boolean))];
 }
 async function json(url,options={}){const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),6000);try{const response=await fetch(url,{credentials:'same-origin',cache:'no-store',...options,signal:controller.signal});if(!response.ok)throw Error('Offer check failed');return await response.json();}finally{clearTimeout(timer);}}
 async function apply(state,options={}){
  if(!cfg.offers||!codes.enabled||!managed.length)return {};
  try{
   const wanted=select(state),cart=Array.isArray(options.cart?.discount_codes)?options.cart:Array.isArray(state.cart.discount_codes)?state.cart:await json(root+'cart.js');
   // Never clear a shopper's unrelated coupon when changing the gift-set tier.
   const existing=Array.isArray(cart.discount_codes)?cart.discount_codes.map(d=>clean(d.code)):appliedCodes(cart);
   const kept=existing.filter(c=>c&&!managed.includes(normal(c)));
   const desired=[...new Set([...kept,...wanted])];
   const current=existing.map(normal).sort().join(',');
   let result=cart,updated=false;
   if(current!==desired.map(normal).sort().join(',')){
    result=await json(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:desired.join(','),...(options.sections?{sections:options.sections,sections_url:options.sections_url||root}:{})})});updated=true;
   }
   const accepted=appliedCodes(result).map(normal);
   const warning=wanted.some(c=>!accepted.includes(normal(c)))?'Check gift-set offers in your checkout summary; an offer could not be confirmed.':'';
   return {updated,warning,sections:result.sections};
  }catch{return {warning:'We could not confirm the gift-set code. Check available offers at checkout.'};}
 }
 window.AGCheckoutOffers={select,apply};
})();
